import { render, staticRenderFns } from "./IconText.vue?vue&type=template&id=4ff663d6&scoped=true&"
import script from "./IconText.vue?vue&type=script&lang=ts&"
export * from "./IconText.vue?vue&type=script&lang=ts&"
import style0 from "./IconText.vue?vue&type=style&index=0&id=4ff663d6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff663d6",
  null
  
)

export default component.exports